import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { BlogApis } from '../../apis/BlogApis';
import './style.css';

export default function Blogs() {
    const [blogs, setBlogs] = useState([]);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const history = useHistory();

    useEffect(() => {
        BlogApis.listAdmin(page, limit, search).then(res => {
            setBlogs(res.data.blogs || []);
            setTotalPages(res.data.pagination.totalPages || 1);
        }).catch(err => {
            if (err.status === 401) {
                localStorage.removeItem('token');
                history.push('/login');
            }
            console.error('Error fetching blogs:', err);
        });
    }, [page, limit, search, history]);

    const handleSearch = (e) => {
        e.preventDefault();
        setPage(1);
        setSearch(searchInput);
    };

    const handleReset = () => {
        setSearchInput('');
        setSearch('');
        setPage(1);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this blog post?')) return;
        try {
            await BlogApis.delete(id);
            setBlogs(prev => prev.filter(b => b.id !== id));
        } catch (err) {
            console.error('Error deleting blog:', err);
        }
    };

    return (
        <div className="app-layout">
            <main>
                <div className="dashboard-header">
                    <h1>Blogs</h1>
                    <Link to="/blogs/new" className="dashboard-header-link">Add Blog</Link>
                </div>

                <div className="filter-section">
                    <form onSubmit={handleSearch} style={{ display: 'flex', gap: '8px' }}>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Search by title..."
                            value={searchInput}
                            onChange={e => setSearchInput(e.target.value)}
                            style={{ width: '260px' }}
                        />
                        <button type="submit" className="btn">Search</button>
                        <button type="button" className="btn" onClick={handleReset}>Reset</button>
                    </form>
                </div>

                <div className="dashboard-section">
                    <div className="dashboard-section-title">Blog Posts</div>
                    <table className="dashboard-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blogs.map(blog => (
                                <tr key={blog.id}>
                                    <td>{blog.title}</td>
                                    <td>{blog.category_name || '—'}</td>
                                    <td>
                                        <span className={`status-badge status-${blog.status}`}>
                                            {blog.status}
                                        </span>
                                    </td>
                                    <td>
                                        {new Date(blog.published_date).toLocaleDateString('en-US', {
                                            month: 'short', day: 'numeric', year: 'numeric'
                                        })}
                                    </td>
                                    <td>
                                        <Link to={`/blogs/${blog.id}/edit`} className="action-link">Edit</Link>
                                        <button
                                            className="action-link action-link-danger"
                                            onClick={() => handleDelete(blog.id)}
                                        >Delete</button>
                                    </td>
                                </tr>
                            ))}
                            {blogs.length === 0 && (
                                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#9ca3af' }}>No blog posts yet</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div>
                    <span style={{ marginRight: '1rem' }}>Page {page} of {totalPages}</span>
                    <button className="btn" onClick={() => setPage(p => p - 1)} disabled={page === 1}>Prev</button>
                    <button className="btn" onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next</button>
                </div>
            </main>
        </div>
    );
}
